<a class="overlay-sidebar-header" [class.overlay-sidebar-header-open]="openSide" (click)="closeOverlay()"></a>
<div class="responsive-btn">
    <a (click)="toggleSidebar()">
        <i class="fa fa-bars text-white" aria-hidden="true"></i>
    </a>
</div>
<div class="navbar m-l-auto justify-content-center" id="togglebtn" [class.openSidebar]="openSide">
    <div class="responsive-btn">
        <a (click)="toggleSidebar()">
            <h5>back</h5>
        </a>
    </div>
    <ul class="main-menu" [class.hover-links]="currentPage != 'main'">
        <!-- Menu -->
        <li *ngFor="let menuItem of menuItems" [class]="menuItem.megaMenu ? 'mega-menu' : ''">
            <!-- Sub -->
            <a href="javascript:void(0)" *ngIf="menuItem.type === 'sub'" class="dropdown menu-sound"
                (click)="setActive(menuItem.title)" [scrollTo]="'#features'" [scrollDuration]="1400">
                {{menuItem.title}}
            </a>
            <!-- Link -->
            <a class="menu-sound" [routerLink]="!menuItem.type ? null : [menuItem.path]" routerLinkActive="active"
                *ngIf="menuItem.type === 'link'">
                {{menuItem.title}}
            </a>
        </li>
    </ul>
</div>